<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_payment_method_banner.jpg')" alt="入出金方法">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <div class="sup-subtab-wrap">
          <router-link class="sup-subtab" to="/page/sup-deposit-bank">
            銀行振込
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-mtpay">
            Match Pay
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-vega">
            VegaWallet
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-jeten">
            Jetonbank
          </router-link>
          <router-link class="sup-subtab sup-subtab--active" to="/page/sup-deposit-usdt">
            USDT購入
          </router-link>
          <router-link class="sup-subtab" to="/page/sup-deposit-crypto">
            仮想通貨
          </router-link>
        </div>
        <h1 class="sup-page-title">
          USDT購入
        </h1>
        <p class="sup-step-caution" style="margin-bottom:16px;">
          ※USDT購入をご利用の場合は、「仮想通貨」でご出金可能です。
        </p>
        <div class="sup-steps-box">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 1
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 残高表示部分ををタップ</p>
              <p>➋ 「入金」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_bank1.jpg')" alt="ステップ1">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 2
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 「USDT購入」を選択</p>
              <p>➋ 金額を選択または入力</p>
              <p>➌ 「入金」をタップ</p>
            </div>
            <p class="sup-step-caution">
              ※【注意】入力金額は日本円（JPY）ではなく米ドル（USD）です。30 と入力した場合、「30ドル分のUSDT」を購入することになります。
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto2.jpg')" alt="ステップ2-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto3.jpg')" alt="ステップ2-2">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 3
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 支払い方法を選択（クレジットカードVisa / Master Card / Google Pay / Apple Pay）</p>
              <p>➋ 「Buy Order USDT」をクリック</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto4.jpg')" alt="ステップ3">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 4
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ メールアドレスを入力</p>
              <p>➋ 「Continue」をクリック</p>
              <p>➌ 入力したメールアドレスに送信された6桁の認証コードを入力</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto5.jpg')" alt="ステップ4-1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto7.jpg')" alt="ステップ4-2">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto8.jpg')" alt="ステップ4-3">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 5
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 支払いの金額と受け取るUSDT金額を確認</p>
              <p>➋ 「Buy」をクリック</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto6.jpg')" alt="ステップ5">
            </div>
          </div>
          <hr class="sup-step-divider">
          <div class="sup-step">
            <p class="sup-step-num">
              ステップ 6
            </p>
            <p class="sup-step-desc">
              下記支払い方法別の手続きを完了すると、「USDTウォレット」へ即時反映。
            </p>
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <div class="sup-step">
            <p class="sup-step-num">
              ※Goole Pay / Apple Payの場合※
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ 指定の支払い方法をクリック</p>
              <p>➋ 「Proceed to payment」をクリックすると、支払い手続き画面へ移動</p>
              <p>➌ 画面の指示に従い、支払い手続きを完了</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto9.jpg')" alt="Google Pay 1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto10.jpg')" alt="Google Pay 2">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto11.jpg')" alt="Apple Pay 1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_crypto12.jpg')" alt="Apple Pay 2">
            </div>
          </div>
        </div>
        <div class="sup-steps-box sup-steps-box--mt">
          <div class="sup-step">
            <p class="sup-step-num">
              ※クレジットカードVisa / Master Cardの場合※
            </p>
            <div class="sup-wallet-content-list">
              <p>➊ カード番号、有効期限、セキュリティコード（CVC）を入力</p>
              <p>➋ 請求先住所を入力</p>
              <p>➌ 「Confirm」をクリックし、カード情報を登録</p>
              <p>➍ 「Proceed to payment」をクリックすると、カード会社の3Dセキュリティ認証画面へ移動</p>
              <p>➎ 画面の指示に従い、支払い手続きを完了</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_bank1.jpg')" alt="クレジットカード 1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_deposit_bank2.jpg')" alt="クレジットカード 2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
